'use client';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionTitle } from '@/components/SectionTitle';
import { type BonusShopTab, getSectionTitle, TAB_TO_TYPE } from '../../helpers';
import type { BonusShopProduct } from '../../types';
import { BonusShopCard } from '../BonusShopCard';

interface BonusShopGridProps {
  products: BonusShopProduct[];
  tab: BonusShopTab;
}

export const BonusShopGrid = ({ products, tab }: BonusShopGridProps) => {
  const { t } = useTranslation('bonusShop');

  const tabProducts = useMemo(() => {
    const type = TAB_TO_TYPE[tab];
    if (!type) return [];

    return products.filter((product) => product.type === type);
  }, [products, tab]);

  return (
    <div className="tab-section">
      <SectionTitle>{getSectionTitle(t, tab)}</SectionTitle>
      <div className="products-grid">
        {tabProducts.map((product) => (
          <BonusShopCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};
